import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { User } from '../../_models/user';
import { DataTableDirective } from 'angular-datatables';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';
import {OrderMenu} from '../../_models/orderMenu';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-returns',
  templateUrl: './returns.component.html',
  styleUrls: ['./returns.component.css']
})
export class ReturnsComponent implements OnInit {

  returnsMainMenu: OrderMenu[] = [
     {displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N"},
     {displayName: "Submitted", tabClicked: "submitted", orderStatus: "SUBMITTED", additional: "N"},
     {displayName: "Awaiting Carrier", tabClicked: "Awaiting Carrier", orderStatus: "AWAITING_CARRIER", additional: "N"},
     {displayName: "In Transit", tabClicked: "inTransit", orderStatus: "IN_TRANSIT", additional: "N"},
    /* {displayName: "Received", tabClicked: "received", orderStatus: "RECEIVED", additional: "N"}, */
     {displayName: "Completed", tabClicked: "completed", orderStatus: "COMPLETED", additional: "N"},
     {displayName: "Cancelled", tabClicked: "cancelled", orderStatus: "CANCELLED", additional: "Y"}
   ];


 @ViewChild(DataTableDirective, {static: false})
         dtElement: DataTableDirective;
         dtOptions: DataTables.Settings = {};
         dtInstance:DataTables.Api;
         dtTrigger = new Subject();
tabClicked : string = "all";

cancelPopUp: string = 'N';
cancelReason: string;
cancelReasons: any;
cancelReasonError: any;
ordId : string;
orders : any;
checkedList1 = [];
errorMessage : string;
checkedList = [];
masterSelected:boolean = false;
previousStatus='';
orderStatus:any='ALL';
  totalRecords:number;
  userDrop2 : any='ALL';
  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private g : Globals, private api: ApiIntegration, public user: User) {
    this.g.page = "Returns";
//this.tabClicked = "all";
//this.populateTabData('all',"ALL");
if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
             this.tabClicked = this.g.pageTab;
             for (let ol of this.returnsMainMenu) {
                if (ol.tabClicked === this.g.pageTab) {
                  this.populateTabData(this.g.pageTab,ol.orderStatus);
                  this.switchPosition(ol);
                }
             }
          } else {
            this.tabClicked = "all";
            this.populateTabData('all',"ALL");
          }
   }

 populate(orderChange){
          this.api.getReturnOrderList(this.user.accountOwnerId,orderChange,"1").subscribe((data: any) => {
          this.g.loaderDisplay = "";
            this.orders = data.responseList;
          }, err => {
              this.g.loaderDisplay = "";

            this.alertService.error('Error',err);
          });
    }

   cancelMultiReturnOrders(orders) {
  this.checkedList=[];
     for (let order of orders) {
          if (order.isSelected) {
             this.returnOrderCancel(order);
          }
     };
  }


        populateTabData(triggered,orderStatus) {
       this.tabClicked = triggered;
       this.orderStatus = orderStatus;
       if(!this.previousStatus){
         this.getStockTransferAccountOwnerByStatus(orderStatus);
       }else{
         this.rerender();
       }

     }

   tabChange(){
   this.checkedList=[];
   this.errorMessage = "";
   this.g.loaderDisplay="display";
   }

switchPosition(om) {
    let index = this.returnsMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.returnsMainMenu[4].displayName) {
      this.returnsMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.returnsMainMenu) {
      if (tmp < this.returnsMainMenu.length) {
        if (om.displayName !== this.returnsMainMenu[tmp].displayName) {
          this.returnsMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

    selectShip(r) {
          if(!r.isSelected){ this.masterSelected = false}
           this.getCheckedShipList();
         }


checkUncheckAll() {
    for (var i = 0; i < this.orders.length; i++) {
          this.orders[i].isSelected = this.masterSelected;
        }
      this.getCheckedShipList();
    }


       getCheckedShipList() {
         this.checkedList = [];
         this.checkedList1 = [];
         for (var i = 0; i < this.orders.length; i++){
           if(this.orders[i].isSelected) {
             this.checkedList.push(this.orders[i]['orderNumber']);
             this.checkedList1.push(this.orders[i]['returnOrderHeaderId']);
             this.ordId = this.orders[i]['returnOrderHeaderId'];
           }
         }

       }
       resetCheckedList(){
         this.checkedList = [];
         this.errorMessage='';
       }
     editReturns(orders) {
                    let i = 0;
                    let ohid;
                    for (let o of orders) {
                         if (o.isSelected) {
                          i = i + 1;
                          ohid = o.returnOrderHeaderId;
                      }
                    };
                    if (i === 1) {
                       this.router.navigate(['/admin/createReturns/'+ ohid]);
                    } else {
                       this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
                    }
                 }


  ngOnInit(): void {
           }

     disableAction(status){
     let disable = true;
     let checkedList = [];
     if(this.orders && this.orders.length){
       for(var i = 0; i < this.orders.length; i++){
       if(this.orders[i].isSelected){
       checkedList.push(this.orders[i]);
       }
      }
     }

     if(checkedList.length == 1){

     if(this.tabClicked === 'submitted'){
     if(status === 'processing order' && checkedList[0].orderStatus === 'CREATED'){
      disable = false;
     }
     if(status === 'created' && checkedList[0].orderStatus !== 'CREATED'){
      disable = false;
     }

     }

     }
   	else {
         disable = true;
       }
       return disable;
     }

  processingOrder(orders){
  console.log(this.checkedList[0],"ttt");
   this.router.navigate(['/admin/returnProcessOrder/' + this.checkedList[0]]);
  }



   getStockTransferAccountOwnerByStatus(status){
     var header1 = new HttpHeaders();
     header1 = header1.append('Content-Type', 'application/json');
     header1 = header1.append('Accept', 'application/json');
     header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
this.dtOptions = {
          "ordering": false,
           pagingType: 'full_numbers',
           lengthMenu:  [20, 50, 100, 200],
           pageLength: 20,
           serverSide: true,
           ajax: (dataTablesParameters: any, callback) => {
             if(this.previousStatus!==this.orderStatus){
               dataTablesParameters.start= 0;
               this.previousStatus = this.orderStatus;
             }
             let query:any={
               orderStatus:this.orderStatus,
               organizationId:1,
               page: dataTablesParameters.start?(dataTablesParameters.start/dataTablesParameters.length):dataTablesParameters.start,
               size: dataTablesParameters.length
             }
             if((dataTablesParameters.search||{}).value && (dataTablesParameters.search||{}).value.trim()!==''){
                              query.searchString=dataTablesParameters.search.value.trim();
                            }
             if (this.user.role == 'ACCOUNT_OWNER' || this.user.role == 'DEMO_ACCOUNT' || this.user.role === "ROLE_USER"){
               query.accountOwnerId=this.user.accountOwnerId;
             }
             this.g.loaderDisplay = "display";
             this.http.get(environment.apiUrl + "api/return-orders", {params:query,headers: header1})
                   .subscribe((resp:any) => {
                     this.orders=resp.responseList;
            this.totalRecords = resp.noOfOrders;

                     this.g.loaderDisplay = "";
                     this.orders.forEach((s)=>{
                       s['isSelected']=false;
                       });
                       callback({
                           recordsTotal: resp.noOfOrders,
                           recordsFiltered: resp.noOfOrders
                       });
                   },
                   (err) => {
                   this.g.loaderDisplay = "";
             this.alertService.error('Error',err);
                   });
           }
       };
    }
           ngAfterViewInit(): void {
             this.dtTrigger.next(true);
           }

           ngOnDestroy(): void {

             this.dtTrigger.unsubscribe();
           }

           rerender(): void {
             this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

               dtInstance.destroy();

               this.dtTrigger.next(true);
             });
           }

 returnOrderCancel(ord) {
     this.g.loaderDisplay = "display";
     var header1 = new HttpHeaders();
     header1 = header1.append('Content-Type', 'application/json');
     header1 = header1.append('Accept', 'application/json');
     header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
     this.http.post(environment.apiUrl + 'api/updateReturnOrder', {
           "accountOwnerId": this.user.accountOwnerId,
           "orderStatus": "CANCELLED",
           "organizationId": 1,
           "returnOrderHeaderId": ord.returnOrderHeaderId,
       },
       {headers: header1}).subscribe(data => {
                       this.g.loaderDisplay = "";
         if (data['code'] == 200) {
                     this.alertService.success('Return Order','Cancelled Successfully');
           let index = this.orders.indexOf(ord);
           this.orders.splice(index, 1);
           this.rerender();
         }
         else{
                         this.alertService.error('Error',data['message']);
                         }
       },
       (err: HttpErrorResponse) => {
                       this.g.loaderDisplay = "";
       });
   }


returnCancel() {
let encoded = unescape(this.cancelReason);
console.log(encoded,"...........");
           this.cancelReasonError = "";
                  if(!this.cancelReason){
           this.cancelReasonError = 'please select reason';
           return false
   }

     this.g.loaderDisplay = "display";
     var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
            header1 = header1.append('Accept', 'application/json');
            header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
     this.http.put(environment.apiUrl + "api/return-orders/cancel/",{
     "returnOrderId" : this.ordId,
     "cancelReason": this.cancelReason,
     },

                        {headers: header1}).subscribe(data => {
                       this.g.loaderDisplay = "";
         if (data['code'] == 200) {
         this.cancelPopUpClose();
         this.alertService.success('Return Order','Cancelled Successfully');
         }
         else{
         this.alertService.error('Error',data['message']);
                         }
       },
       (err) => {
                       this.g.loaderDisplay = "";
                       this.alertService.error('Error',err);
       });
   }


cancelPopUpClose(){
  this.cancelPopUp = 'N';
  this.cancelReason = "";
  this.cancelReasonError = "";
  }


onCancel(){
this.cancelPopUp = 'Y';
}


typeError(){
           this.cancelReasonError='';
           if(this.cancelReason == null || this.cancelReason == undefined || this.cancelReason == ""){
           this.cancelReasonError= "Please enter the Reason for Cancellation"
          }
          }
    }

